export const environment = {
  production: true,
  http_debug: false,
  graphql: {
    endpoint: "https://extranet3-api.nefco.net/graphql",
    socket_endpoint: "wss://extranet3-api.nefco.net/subscriptions"
  },
  auth0: {
    domain: "atom-group.auth0.com",
    clientId: "IMH6TvDuqUUJUSvWHe6IZBvT578bB2ju"
  },
  notifyTimeoutMs: 5000,
  portal: {
    base_url: "https://extranet3-api.nefco.net",
    contactEmail: "noreply@nefco.net"
  },
  env: 'PROD',
  cloudFrontS3: "https://d13176vfi277y.cloudfront.net", /* DISPLAY PHOTO */
  resizeApiURL: 'https://mq5vdb2v62.execute-api.us-east-1.amazonaws.com', /* RESIZE PHOTO */
};
